export default {
  REPORT_STORE_FETCH: 'REPORT_STORE_FETCH',
  REPORT_STORE_FETCH_COMPLETE: 'REPORT_STORE_FETCH_COMPLETE',
  REPORT_STORE_FETCH_ERROR: 'REPORT_STORE_FETCH_ERROR',

  COLLECTIONS_STORE_FETCH: 'COLLECTIONS_STORE_FETCH',
  COLLECTIONS_STORE_FETCH_COMPLETE: 'COLLECTIONS_STORE_FETCH_COMPLETE',

  USER_REPORT_STORE_FETCH: 'USER_REPORT_STORE_FETCH',
  USER_REPORT_STORE_FETCH_COMPLETE: 'USER_REPORT_STORE_FETCH_COMPLETE',
}
